<template>
  <div class="friendly-link mt-20">
    <block-head 
      title="友情链接" 
      subtitle="/ 同行相链，让专业更有力量" 
      icon="link" 
      hid-more-btn 
    />
    
 
  </div>
</template>

<script>
import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "FriendlyLink",
  components: { BlockHead },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">

</style>